import React from 'react';
import { MENU_INFO_ROUTES } from '@/navigators/routes';
import { MenuItemDetailComponent } from '@/components/menu/menu-item-detail-component';
import { MenuStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';
import { useMenuInfoContext } from '@/contexts/menu-info-context';

type Props = StackScreenProps<MenuStackParams, MENU_INFO_ROUTES.ItemDetail>;

export const MenuItemDetailScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const {
    params: { menuItemUUID },
  } = route;
  const { menuItemMap } = useMenuInfoContext();
  const menuItem = menuItemMap.get(menuItemUUID);

  return menuItem ? (
    <MenuItemDetailComponent
      menuItem={menuItem}
      onDeleteMenuItem={() => navigation.navigate(MENU_INFO_ROUTES.Base)}
    />
  ) : null;
};
